import PropTypes from 'prop-types';
import React from 'react';
import AchievementsBadgeHighlightedSmall from '@strava/icons/AchievementsBadgeHighlightedSmall';
import AchievementsKomHighlightedSmall from '@strava/icons/AchievementsKomHighlightedSmall';
import AchievementsMedal02Small from '@strava/icons/AchievementsMedal02Small';
import AchievementsMedal03Small from '@strava/icons/AchievementsMedal03Small';
import AchievementsMedalPrSmall from '@strava/icons/AchievementsMedalPrSmall';
import AchievementsTrophy02Small from '@strava/icons/AchievementsTrophy02Small';
import AchievementsTrophy03Small from '@strava/icons/AchievementsTrophy03Small';
import AchievementsTrophy04Small from '@strava/icons/AchievementsTrophy04Small';
import AchievementsTrophy05Small from '@strava/icons/AchievementsTrophy05Small';
import AchievementsTrophy06Small from '@strava/icons/AchievementsTrophy06Small';
import AchievementsTrophy07Small from '@strava/icons/AchievementsTrophy07Small';
import AchievementsTrophy08Small from '@strava/icons/AchievementsTrophy08Small';
import AchievementsTrophy09Small from '@strava/icons/AchievementsTrophy09Small';
import AchievementsTrophy10Small from '@strava/icons/AchievementsTrophy10Small';

export const LegacySpriteToStravaUiIcon = ({ sprite }) => {
  const GOLD = '#FEC835';
  const SILVER = '#999999';
  const BRONZE = '#E5820A';

  switch (sprite) {
    case 'icon-at-kom-1':
      return <AchievementsKomHighlightedSmall fill={GOLD} />;
    case 'icon-at-kom-2':
      return <AchievementsTrophy02Small fill={GOLD} />;
    case 'icon-at-kom-3':
      return <AchievementsTrophy03Small fill={GOLD} />;
    case 'icon-at-kom-4':
      return <AchievementsTrophy04Small fill={GOLD} />;
    case 'icon-at-kom-5':
      return <AchievementsTrophy05Small fill={GOLD} />;
    case 'icon-at-kom-6':
      return <AchievementsTrophy06Small fill={GOLD} />;
    case 'icon-at-kom-7':
      return <AchievementsTrophy07Small fill={GOLD} />;
    case 'icon-at-kom-8':
      return <AchievementsTrophy08Small fill={GOLD} />;
    case 'icon-at-kom-9':
      return <AchievementsTrophy09Small fill={GOLD} />;
    case 'icon-at-kom-10':
      return <AchievementsTrophy10Small fill={GOLD} />;
    case 'icon-at-pr-1':
    case 'icon-yr-pr-1':
      return <AchievementsMedalPrSmall fill={GOLD} />;
    case 'icon-at-pr-2':
    case 'icon-yr-pr-2':
      return <AchievementsMedal02Small fill={SILVER} />;
    case 'icon-at-pr-3':
    case 'icon-yr-pr-3':
      return <AchievementsMedal03Small fill={BRONZE} />;
    default:
      return <AchievementsBadgeHighlightedSmall fill={SILVER} />;
  }
};

LegacySpriteToStravaUiIcon.propTypes = {
  sprite: PropTypes.string.isRequired
};

export default LegacySpriteToStravaUiIcon;
